var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{ref:"modal",attrs:{"id":"set-owner-user-modal","buttonColor":true,"close-button-label":_vm.$t("button.cancel"),"loading":_vm.loading,"process-button-label":_vm.processButtonLabel,"title":_vm.title},on:{"process":_vm.handleProcess}},[_c('div',{staticClass:"span text"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }